import React from 'react';

/**
 * InputAnswerAlert component that shows a full screen alert for answer submissions
 * 
 * @param {Object} props
 * @param {boolean} props.isCorrect - Whether the answer is correct
 * @param {Function} props.onClose - Function to handle closing the alert
 */
const InputAnswerAlert = ({ isCorrect, onClose }) => {
  // Determine text and styles based on whether the answer is correct
  const title = isCorrect 
    ? "おめでとう🎉大正解🥳！" 
    : "残念💧不正解！"; // Blue tears emoji for incorrect answers
  
  const bgColor = isCorrect ? "bg-green-500" : "bg-red-500";
  
  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center" 
      style={{
        position: 'fixed', 
        zIndex: 10000,
        fontFamily: "Hiragino",
      }}
    >
      <div className="w-[90%] max-w-sm animate-fadeIn scale-100">
        <div className={`${bgColor} text-white p-6 rounded-t-lg text-center transform transition-transform duration-300`}>
          <h2 className="text-2xl font-bold">{title}</h2>
        </div>
        <div className="bg-white/90 p-4 rounded-b-lg flex justify-center">
          <button
            onClick={onClose}
            className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-8 py-2 rounded-full text-lg font-medium shadow-md active:transform active:scale-95 transition-transform"
          >
            閉じる
          </button>
        </div>
      </div>
    </div>
  );
};

export default InputAnswerAlert; 